var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresentationAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 36 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M662.205,232.721a8.888,8.888,0,0,1-1.088-.358,4.074,4.074,0,0,1-2.5-3.875c-.032-3.045-.009-6.09-.009-9.136q0-15.039,0-30.078a4.2,4.2,0,0,1,4.456-4.544q9.362,0,18.725-.01a2.076,2.076,0,0,1,1.593.677q5.285,5.4,10.6,10.768a2.046,2.046,0,0,1,.621,1.542q-.016,15.18-.007,30.359a4.221,4.221,0,0,1-3.52,4.606.325.325,0,0,0-.079.047Zm18.546-45.179H663.024c-1.136,0-1.649.529-1.649,1.7q0,19.494,0,38.989c0,1.155.522,1.681,1.666,1.681h27.124c1.138,0,1.658-.53,1.658-1.689q0-14.457,0-28.913v-.516h-.57c-2.122,0-4.244.013-6.366,0a4.116,4.116,0,0,1-4.059-3.514,10.1,10.1,0,0,1-.074-1.586C680.747,191.657,680.751,189.629,680.751,187.542Zm2.769,2.115c0,1.612,0,3.215,0,4.817a1.4,1.4,0,0,0,1.51,1.5c1.4,0,2.793,0,4.189,0h.527Z",
    transform: "translate(-658.599 -184.721)",
    fill: "#393939"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentationAlt);
export default __webpack_public_path__ + "static/media/presentation-alt.4f1ff90471173401970d03ef378b5c76.svg";
export { ForwardRef as ReactComponent };